// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"55","mainNavHeight":"64","mainNavZIndex":"1040","shopNavigationHeight":"56","stickyHeaderHeight":"91"};